import React from 'react'

//import { useTranslation } from 'react-i18next'
//import { TITLE } from './constants'
import { useStripeTablesConfig } from './hooks/table'
import { PageOutputChartsTable } from '@ublique/components/Template'
const ReportPivot = () => {
  //const { t } = useTranslation('OutputView')
  const { stripeTables } = useStripeTablesConfig()

  return (
    <PageOutputChartsTable /* title={t(TITLE)} */ stripeTables={stripeTables} />
  )
}

export default ReportPivot
